module.exports = __webpack_public_path__ + "media/public/fonts/QanelasBold/QanelasBold-e223f4afea0eb7823adb05a11bbf4645.svg";